import React from 'react';
import dropboxlogo from '../images/logo-trusted/dropbox-logo.png';
import microsoftlogo from '../images/logo-trusted/microsoft-logo.png';
import intellogo from '../images/logo-trusted/intel-logo.png';
import amdlogo from '../images/logo-trusted/amd-logo.png';
import wiredlogo from '../images/logo-trusted/wired-logo.jpg';
import '../gral-stylesheets/trusted.scss';


class Trusted extends React.Component {
  render() {
    return (
      <div className='trusted-container'>
        <div className='trusted-content-container'>
          <h3>TRUSTED BY</h3>
          <div className='trusted-content-logos'>
            <div className='image-box'>
              <img src={dropboxlogo} alt='Dropbox-logo' />
            </div>
            <div className='image-box'>
              <img src={microsoftlogo} alt='Microsoft-logo' />
            </div>
            <div className='image-box'>
              <img src={intellogo} alt='Intel-logo' />
            </div>
            <div className='image-box'>
              <img src={amdlogo} alt='AMD-logo' />
            </div>
            <div className='image-box'>
              <img src={wiredlogo} alt='WIRE-logo' />
            </div>
          </div>
        </div>
      </div >
    )
  }
}

export default Trusted;